import type { ThemeDefinition } from './types';

export const modernMinimal: ThemeDefinition = {
  id: 'modern-minimal',
  name: 'Modern Minimal',
  description: 'Clean modern design — white, grey, and blue accent with minimal borders',
  mode: 'light',
  tokens: {
    colorPrimary: '#2563EB',
    colorSecondary: '#64748B',
    colorAccent: '#0EA5E9',
    colorSuccess: '#16A34A',
    colorWarning: '#D97706',
    colorError: '#DC2626',
    colorInfo: '#2563EB',
    colorBgBase: '#F8FAFC',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBgSidebar: '#1E293B',
    colorText: '#0F172A',
    colorTextSecondary: '#475569',
    colorTextTertiary: '#94A3B8',
    colorBorder: '#E2E8F0',
    colorBorderSecondary: '#F1F5F9',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03)',
    boxShadowSecondary: '0 4px 16px rgba(0,0,0,0.06), 0 8px 24px rgba(0,0,0,0.04)',
    glassBlur: '16px',
    glassOpacity: '0.40',
    glassSaturation: '140%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontFamilyHeading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontSizeHeading: 20,
    borderRadius: 8,
    borderRadiusLG: 16,
    cardBorder: '#E2E8F0',
    cardShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
};
